<template>
  <div @click="goToWeather" class="park">
      <span>{{city.city}}</span>
      <span> 
            {{ time }}
      </span>
      <div class="weather">
            <span>{{ Math.round(city.currentWeather.main.temp) }}&deg;</span>
            <img :src="require(`../../public/conditions/${city.currentWeather.weather[0].icon}.svg`)" alt="" />
        </div>
        <div class="video">
            <video autoplay loop muted :src="require(`../../public/videos/${city.currentWeather.weather[0].icon}.mp4`)"></video>
        </div>
  </div>
</template>

<script>
export default {
    name: "park",
    props: ["city"],
    data() {
        return {
            date: null,
            h: null,
            m: null,
            mm:null,
            time: null,
            utc: null,
            offset: null,
            currentWeather: null,
            t: 0,
        };
    },
    created() {
    this.showDate();
     },
    
    mounted() {
       this.refresh(); 
    },
    methods: {
        goToWeather() {
           this.$router.push({name: "Weather", params: { city: this.city.city }});
        },
        showDate() {
            this.utc = Date.now();
            this.offset = (this.city.currentWeather.timezone) * 1000;
            this.date = new Date(this.utc + this.offset);
            this.h = this.date.getUTCHours();
            this.m = this.date.getUTCMinutes();
            if(this.h < 10) { this.h = "0" + this.h }
            if(this.m < 10) { this.m = "0" + this.m }
            this.time = this.h + ':' + this.m 
            return this.time
        },
        refresh(){
            this.t = 36000;
            setInterval(this.showDate,this.t)
        }
    }
}
</script>

<style lang="scss" scoped>
.park {
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    flex-basis: 50%;
    min-height: 250px;
    color: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    
    span {
        z-index: 1;
        text-transform: capitalize;
        display: block;
        font-size: 25px;
        font-weight: 600;
    }
    
    .weather {
        display: flex;
        z-index: 1;
        justify-content: flex-end;
        align-items: flex-end;
        flex: 1;
        
        span {
            font-size: 35px;
            margin-right: 8px;
        }
        
        img {
            height: 20px;
            width: auto;
        }
    }
    
    .video {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        
        video {
            height: 100%;
            @media (min-width: 900px) {
                height: auto;
                width: 100%;
            }
        }
    }  
}
</style>
